import { render, staticRenderFns } from "./PreviewPageFooterSection.vue?vue&type=template&id=ac7b51a4&"
import script from "./PreviewPageFooterSection.vue?vue&type=script&lang=js&"
export * from "./PreviewPageFooterSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports